/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 15:12:16
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-22 18:17:06
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/EnableConfig/index.tsx
 */
import React from 'react';

import css from './css.less';

import { Switch } from 'src/components/Antd';

import { useDispatch, useSelector } from 'react-redux';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { onEnabledChange } from '../slice';
const EnableConfig = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { withoutCollapse } = props;
  const enabled = useSelector(
    (state: any) => state?.salesChannelContent?.productSearch?.enabled,
  );
  const _d = useDispatch();
  const handleOnChange = (e) => {
    _d(onEnabledChange(e));
  };
  return (
    <div
      className={`${css.container} ${withoutCollapse ? css.fieldSection : ''}`}>
      <div className={css.contentContainer}>
        <div className={css.text}>
          {getI18n('salesChannelContent.index.enableProductSearch')}
        </div>
        <Switch onChange={handleOnChange} checked={enabled} />
      </div>
    </div>
  );
};
export default EnableConfig;
